import { USER_TYPE } from "modules/users/types/UserTypesEnum";
import axiosInstance from "services/AxiosInstance";
import { ResponseType } from "types";
import { getAccountId } from "utils/common.utils";

import { ImportInterface } from "../types";

export interface GetUserInterface {
  limit?: number;
}
export const getImportListService = async (
  pageNo: number,
  limit: number,
  userType: string,
  filterParams?: string,
  accountId?: string
): Promise<ResponseType<ImportInterface[], { totalCount: number }>> => {
  const params: GetUserInterface = {
    limit: limit
  };
  const queryParamsPart = filterParams ? `?${filterParams}` : "";
  const accountIdentifier = accountId ?? getAccountId();
  let importUrl = "/imports" + queryParamsPart;
  if (userType === USER_TYPE.external) {
    importUrl = "/imports/account/" + accountIdentifier + queryParamsPart;
  }
  const response = await axiosInstance.get(importUrl, { params });
  return response.data;
};
